import React, { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PersonIdNameTimezone } from '@redux/person/personTypes';
import { AddUserIcon } from 'components/Icons';
import { SearchField } from 'components/SearchField/SearchField';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import { getInitials } from 'utils/util';
import style from './ActivePersonSelect.scss';

type ActivePersonSelectProps = {
  activePersons: PersonIdNameTimezone[];
  patientSelectionChanged: (patientId: string) => void;
  error: boolean;
};

export const ActivePersonSelect: React.FC<ActivePersonSelectProps> = ({ activePersons, patientSelectionChanged, error }) => {
  const navigate = useNavigate();
  const [personSearchText, setPersonSearchText] = useState<string>('');

  const containsText = (text, searchText) => text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
  const activePersonsOptions = useMemo(() => activePersons.filter((person) => containsText(person.fullName, personSearchText)), [personSearchText]);

  const goToNewPatientPage = useCallback(() => {
    navigate('/patients/newPatient');
  }, [navigate]);

  return (
    <div className={style.activePersonSelectContainer}>
      <div className={style.filterContainer}>
        <SearchField searchText={personSearchText} setSearchText={setPersonSearchText} placeholder="Search Patient" />
      </div>

      <div className={style.activePatientsContainer}>
        <div className={style.activePatientItemContainer} onClick={goToNewPatientPage}>
          <div className={style.avatar}>
            <AddUserIcon color={Color.DARK_BLUE_NEW} width={24} height={24} />
          </div>
          <Text variant="nlg" className={style.addNewPatientText}>
            Add new patient
          </Text>
        </div>
        <div className={style.bottomLine} />
        {activePersonsOptions.map((option) => (
          <div className={style.activePatientItemContainer} key={option.personId} onClick={() => patientSelectionChanged(option.personId)}>
            <div className={style.avatar}>
              <Text variant="md" weight={500}>
                {getInitials(option.fullName)}
              </Text>
            </div>
            <div className={style.activePatientInfoContainer}>
              <Text variant="nlg" className={style.activePatientInfoFullname}>
                {option.fullName}
              </Text>
              <Text variant="md" className={style.activePatientInfoEmail}>
                {option.email}
              </Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
